"use client";

import { Separator } from "@radix-ui/react-dropdown-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuSeparatorProps } from "../types";

function DropdownMenuSeparator({
  className,
  ...props
}: DropdownMenuSeparatorProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Separator
      data-slot="dropdown-menu-separator"
      className={cn("bg-border -mx-1 my-1 h-px", className, classes)}
      {...native}
    />
  );
}

DropdownMenuSeparator.displayName = "DropdownMenu.Separator";

export default DropdownMenuSeparator;
